export default __webpack_public_path__ + "media/images/react_icons/logout_fi-ce8f04fe50cf0a41bf5c38fa458f9f2f.svg";